import React from "react";
import "./companyAddress.css";
import { Box, Typography } from "@mui/material";

const CompanyAddressPage: React.FC = () => {
  return (
    <div className="CompanyAddressContainer">
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Typography
          sx={{ fontSize: "24px", color: "#fff", fontWeight: "bold" }}
        >
          Company Addresses
        </Typography>
      </Box>

      <Box className="addressContainer" sx={{ color: "#fff", p: 3, px: 0 }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: "400", mb: 1, fontSize: "20px" }}
        >
          Royal Enfield Global Headquarters
        </Typography>
        <Typography>296, Rajiv Gandhi Salai, Sholinganallur,</Typography>
        <Typography>Chennai, Tamil Nadu 600119</Typography>

        <Typography
          variant="h6"
          sx={{ fontWeight: "400", mt: 3, mb: 1, fontSize: "20px" }}
        >
          Royal Enfield UK Technology Centre
        </Typography>
        <Typography>Bruntingthorpe Proving Ground, Bath Lane,</Typography>
        <Typography>Leicestershire, LE17 5QS, United Kingdom</Typography>

        <Typography
          variant="h6"
          sx={{ fontWeight: "400", mt: 3, mb: 1, fontSize: "20px" }}
        >
          Royal Enfield Gurgaon
        </Typography>
        <Typography>
          ThinkPlus Plot 18, Sector 32, Institutional Area
        </Typography>
        <Typography>Gurugram, Haryana 12202</Typography>

        <Typography
          variant="h6"
          sx={{ fontWeight: "400", mt: 3, mb: 1, fontSize: "20px" }}
        >
          Brazil (Sao Paulo)
        </Typography>
        <Typography>Rua Marilia 336, Condomínio Marambaia</Typography>
        <Typography>Vinhedo - Sao Paulo - Brasil, Cep 13287-170</Typography>

        <Typography
          variant="h6"
          sx={{ fontWeight: "400", mt: 3, mb: 1, fontSize: "20px" }}
        >
          Thailand (Bangkok)
        </Typography>
        <Typography>Royal Enfield (Thailand) Ltd.</Typography>
        <Typography>90 CW Tower, Building B, Room No. B2602,</Typography>
        <Typography>
          26th Floor, Ratchadapisek Road, Huai Khwang Sub-district,
        </Typography>
        <Typography>Huai Khwang District, Bangkok 10310</Typography>

        <Typography
          variant="h6"
          sx={{ fontWeight: "400", mt: 3, mb: 1, fontSize: "20px" }}
        >
          USA (Milwaukee)
        </Typography>
        <Typography>Royal Enfield North America Limited,</Typography>
        <Typography>226 North Water Street, Milwaukee, WI 53202</Typography>
      </Box>
    </div>
  );
};

export default CompanyAddressPage;
